import React, { useEffect, useState } from 'react';

const CardControleDocaHeaderComponent = (props: any) => {
    const [classModoDark, setClassModoDark] = useState(' bg-dark text-white'); 
    const [letraPainel, setletraPainel] = useState('#57f542'); 

    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    useEffect(() => {
        if(preferences.darkMode == true){
            setClassModoDark(' bg-dark text-white');
            setletraPainel('#57f542');
        } else {
            setClassModoDark(' bg-light');
        }
    }, []);

    return (
    <div className="card-group card-group-doca' width-doca-progress-bar m-1" style={{backgroundColor:props.horario.cor, width: '160px'}}>
            <div className="card-body" style={{textAlign:'center', fontSize:'16pt', fontWeight: 'bold', color: '#FFF'}}>
                <section className='card-doca'>
                    <div style={{borderRadius:'2px'}}>
                        {props.horario.quantidade}
                    </div>
                    
                    <div>
                        {props.horario.horario ?? 'Vazio'}
                    </div>
                </section>
        </div>
    </div>
    );
}

export default CardControleDocaHeaderComponent
